export const COEFFICIENTS = {
  age: 0.0412,
  sex: 0.1756,
  eGFR: -0.0194,
  eGFRc2: 0.0174,
  hemo: -0.0187,
  albuminuriaMild: 0.2283,
  albuminuriaHEavy: 0.3100,
  charlsonCHF: 0.5266,
  charlsonCOPD: 0.2171,
  liverDis: 0.4843,
  charlsonPVD: 0.2373,
  diabetes: 0.0801,
  priorInv: -0.1467
};

export const BASELINES = {
  age: -73.62,
  eGFR: -51.12,
  hemo: -130.95
};

export const FACTOR = {
  conservativeMgmt: 1
};
